import React, { useState, useRef, useEffect } from 'react';
import config from '../config';

const FloatingIntroVideo = ({ show, onClose }) => {
  const [videoUrl, setVideoUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [countdown, setCountdown] = useState(10);
  const [showCountdown, setShowCountdown] = useState(true);
  const [isMaximized, setIsMaximized] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (show && !videoUrl) {
      loadVideo();
    }
  }, [show]);

  useEffect(() => {
    if (show && showCountdown) {
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            setShowCountdown(false);
            setIsClosing(true);
            // Start fade-out animation, then close after animation completes
            setTimeout(() => {
              onClose();
            }, 500); // 500ms fade-out duration
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [show, showCountdown, onClose]);

  const loadVideo = async () => {
    try {
      setLoading(true);
      // Use direct URL from config instead of requesting signed URL
      setVideoUrl(config.introVideo.url);
    } catch (err) {
      console.error('Error loading intro video:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowCountdown(false);
    onClose();
  };

  const handleVideoClick = () => {
    setShowCountdown(false);
    setIsMaximized(true);
  };

  const handleMaximizedClose = () => {
    setIsMaximized(false);
    onClose();
  };

  if (!show) {
    return null;
  }

  // Maximized view
  if (isMaximized) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-80 overflow-y-auto h-full w-full z-50">
        <div className="relative top-10 mx-auto p-5 border w-11/12 md:w-4/5 lg:w-3/4 max-w-6xl shadow-lg rounded-md bg-white">
          <div className="mt-3">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl leading-6 font-medium text-gray-900">
                Introducción a Virtus Auto
              </h3>
              <button
                onClick={handleMaximizedClose}
                className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
              >
                ×
              </button>
            </div>
            
            {loading && (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                <span className="ml-3 text-gray-600">Cargando video...</span>
              </div>
            )}

            {videoUrl && !loading && (
              <div className="relative">
                <video
                  ref={videoRef}
                  src={videoUrl}
                  className="w-full h-auto max-h-[70vh] rounded-lg"
                  controls
                  autoPlay
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Floating view
  return (
    <div className={`fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-lg border-2 border-gray-300 overflow-hidden transition-all duration-500 ease-in-out ${
      isClosing ? 'opacity-0 transform translate-y-4 scale-95' : 'opacity-100 transform translate-y-0 scale-100'
    }`}>
      <div className="relative w-80 h-48">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 z-50 bg-black bg-opacity-50 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-opacity-70"
        >
          ×
        </button>

        {/* Countdown overlay */}
        {showCountdown && (
          <div 
            className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center z-40 cursor-pointer"
            onClick={handleVideoClick}
          >
            <div className="text-center text-white">
              <div className="text-2xl font-bold mb-2">{countdown}</div>
              <div className="text-sm">Se cerrará automáticamente</div>
              {/* <div className="text-xs mt-2 opacity-75">Haz clic para verlo completo</div> */}
            </div>
          </div>
        )}

        {loading && (
          <div className="flex justify-center items-center h-full">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          </div>
        )}

        {videoUrl && !loading && (
          <video
            ref={videoRef}
            src={videoUrl}
            className="w-full h-full object-cover cursor-pointer"
            muted
            autoPlay
            loop
            onClick={handleVideoClick}
          />
        )}

        {/* Video title overlay */}
        {/* <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-2">
          <p className="text-white text-xs font-medium">
            Video de Formación Inicial
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default FloatingIntroVideo;
